/**
 * /map の左右リスト幅のうち、この画面だけの値（既定幅と localStorage キー）。
 * 上下限・clamp・器への収め方は共有の components/dispatch/panelResize/panelWidth.ts。
 *
 * Why 画面ごとに持つ: 既定幅が画面ごとに違う（/map は左 360・右 340、カード配車は
 * 左 320・右 380）。キーを共有すると、どちらかの初回表示を変えることになる。
 */

/** 既定は変更前の固定値そのまま。初回表示の見た目を変えない */
export const DEFAULT_LEFT_PANEL_WIDTH = 360;
export const DEFAULT_RIGHT_PANEL_WIDTH = 340;

export const LEFT_PANEL_WIDTH_STORAGE_KEY = 'map.leftPanelWidth';
export const RIGHT_PANEL_WIDTH_STORAGE_KEY = 'map.rightPanelWidth';
